import isPlainObject from 'lodash/isPlainObject';
import UserStateInterface from '../types/userState';

export default function userStateReducer(
  previousValue: UserStateInterface,
  action: { type: string; payload: UserStateInterface }
): UserStateInterface {
  const { payload } = action;
  const oldSession = previousValue?.userState?.SESSION;
  const newSession = payload?.userState?.SESSION;
  switch (action.type) {
    case 'UPDATE':
      if (oldSession?.sn !== newSession?.sn) {
        return {
          ...previousValue,
          ...(isPlainObject(action.payload) ? action.payload : {}),
          error: null
        };
      } else if (payload.error) {
        return {
          error: payload.error
        };
      } else {
        return previousValue;
      }
    default:
      return previousValue;
  }
}
